export const FILE_ICON: {[key: string]: string} = {
  ['application/pdf']: 'icon-format-pdf',
  ['image/png']: 'icon-format-image',
  ['image/jpg']: 'icon-format-image',
  ['image/jpeg']: 'icon-format-image',
}
